import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { selectVideo } from '../selectors/videos.selector';
import { videosActions } from '../actions/videos.actions';
import { filter } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class VideosFacade {
    private store = inject(Store);

    readonly video = (id: string) => this.store.selectSignal(selectVideo(id));
    readonly video$ = (id: string) => this.store.select(selectVideo(id));
    readonly videoNonNullable$ = (id: string) => this.store.select(selectVideo(id)).pipe(filter((video) => video !== null));

    getVideo(id: string): void {
        this.store.dispatch(videosActions.getVideo({ id }));
    }

    clear(): void {
        this.store.dispatch(videosActions.clear());
    }
}
